import { on } from "@ember-decorators/object"
import Component from "@ember/component"

export default class ScrollTo extends Component {
  @on("didReceiveAttrs")
  onDidReceiveAttrs({ oldAttrs, newAttrs }) {
    if (
      oldAttrs === undefined ||
      (oldAttrs.top.value !== newAttrs.top.value && newAttrs.top.value !== undefined)
    ) {
      // Ember.run.scheduleOnce('afterRender', function(){
      //   window.scrollTo(0, newAttrs.top.value)
      // })
    }
  }
}
